module.exports = __webpack_public_path__ + "img/ingredienten-laab-kai.eeae60a1.jpeg";